import enUS from './GE';

export default {
  'en-US': enUS
}
